import { defineClientComponent } from './src/js/clientComponents.ts';
import Component from './src/pages/sanity/page/ListPage/Grapes/[slug].tsx';
defineClientComponent('sanity/page/ListPage/Grapes/[slug]', Component);